'use client';

import { LoadToolsResultCard } from '../trace-view/components/LoadToolsResultCard';
import { InlineToolExpand } from './InlineToolExpand';
import { ToolResultRenderer } from './ToolCallsRenderers/ToolResultRenderer';
import type { ToolResultData } from './ToolCallsRenderers/types';
import { getToolDisplayTextForInline } from './ToolCallsRenderers/tool-categories';
import type { OnOpenChatObject } from './hitl-types';

type InlineToolCallExpandProps = {
  toolName: string;
  input?: unknown;
  output?: unknown;
  status?: string;
  displayLabel: string;
  hasStreamedLabel: boolean;
  canShowContent: boolean;
  isSkillReadToolCall: boolean;
  intelligenceOutputData: ToolResultData | null;
  error?: string;
  onOpenObject?: OnOpenChatObject;
  liveLabel?: string;
  expansionKey?: string;
};

function readOutputText(output: unknown): string | undefined {
  return typeof output === 'string' && output.trim().length > 0
    ? output
    : undefined;
}

export function InlineToolCallExpand({
  toolName,
  input,
  output,
  status,
  displayLabel,
  hasStreamedLabel,
  canShowContent,
  isSkillReadToolCall,
  intelligenceOutputData,
  error,
  onOpenObject,
  liveLabel,
  expansionKey,
}: InlineToolCallExpandProps) {
  const isLoadTools =
    toolName.replace(/_/g, '-').toLowerCase() === 'load-tools';
  const displayText =
    isLoadTools || !hasStreamedLabel
      ? getToolDisplayTextForInline(toolName, input || output, status)
      : displayLabel;
  const loadedToolsOutput = isLoadTools ? readOutputText(output) : undefined;

  return (
    <InlineToolExpand
      toolName={toolName || 'unknown'}
      displayText={displayText}
      status={status}
      error={error}
      onOpenObject={onOpenObject}
      liveLabel={liveLabel}
      expansionKey={expansionKey}
    >
      {loadedToolsOutput ? (
        <LoadToolsResultCard output={loadedToolsOutput} />
      ) : canShowContent && intelligenceOutputData && !isSkillReadToolCall ? (
        <ToolResultRenderer
          data={intelligenceOutputData}
          onOpenObject={onOpenObject}
        />
      ) : null}
    </InlineToolExpand>
  );
}
